import { defineMessages } from 'react-intl'

export default defineMessages({
  clientId: {
    id: 'SpaceCustomAppEditPage.ConnectorInstance.ClientId',
    defaultMessage: 'Client Id'
  },
  clientSecret: {
    id: 'SpaceCustomAppEditPage.ConnectorInstance.ClientSecret',
    defaultMessage: 'Client Secret'
  },
  copy: {
    id: 'COPY',
    defaultMessage: 'COPY'
  },
  iconUrl: {
    id: 'SpaceCustomAppEditPage.CustomConnectorForm.IconURL',
    defaultMessage: 'Icon URL'
  },
  name: {
    id: 'Name',
    defaultMessage: 'Name'
  },
  ok: {
    id: 'OK',
    defaultMessage: 'OK'
  },
  onlyDisplayedOnce: {
    id: 'SpaceCustomAppEditPage.CustomConnectorForm.OnlyDisplayedOnce',
    defaultMessage: '(this is only displayed once!)'
  },
  webHookUrl: {
    id: 'SpaceCustomAppEditPage.CustomConnectorForm.WebHookUrl',
    defaultMessage: 'Web Hook URL'
  }
})
